import { Injectable } from '@angular/core';
import { apis, HttpRequestSettings } from '@sb-shared/models/request-settings';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { TimedCacheService } from '@sb-shared/services/timed-cache.service';
import { Observable, shareReplay } from 'rxjs';
import { Inbox } from '../models/inbox';
import { messageViewingFilters } from '../models/requests/message-viewing-filters';

@Injectable({
  providedIn: 'root'
})
export class MessageViewingService {
  config: HttpRequestSettings = {
    api: apis.Web,
    showSuccessToast: false
  }
  baseUrl = 'WebMessageViewer/';

  currentPersonId: number;

  private readonly personUnreadCountCacheKey = 'getPersonUnreadCount';
  private allLookups$: Observable<any>;

  constructor(
    private http: HttpWebApiService,
    private timedCacheService: TimedCacheService
  ) { }

  getPersonInbox(filters: messageViewingFilters): Observable<Inbox> {
    return this.http.post(this.baseUrl + 'GetPersonInbox', filters, this.config);
  }

  getPersonInboxUnfiltered(filters: messageViewingFilters) {
    return this.http.post(this.baseUrl + 'GetPersonInboxUnfiltered', filters, this.config);
  }

  getPersonUnreadCount(): Observable<number> {
    return this.timedCacheService.getObservable(
      this.personUnreadCountCacheKey,
      this.http.get(`${this.baseUrl}GetUnreadCount`, this.config),
      60 * 1000
    );
  }

  clearPersonUnreadCountCache(): void {
    this.timedCacheService.clearCache(this.personUnreadCountCacheKey);
  }

  markAllAsRead(): Observable<any> {
    return this.http.post(this.baseUrl + 'MarkAllAsRead', null, this.config);
  }

  getSpecificMessage(messageId: number): Observable<any> {
    return this.http.post(this.baseUrl + 'GetSpecificMessage', messageId, this.config);
  }

  starMessage(messageId: number, starred: boolean): Observable<any> {
    return this.http.get(this.baseUrl + 'StarMessage', {
      ...this.config,
      params: { messageId, starred }
    });
  }

  archiveMessage(messageId: number, archived: boolean): Observable<any> {
    return this.http.get(this.baseUrl + 'ArchiveMessage', {
      ...this.config,
      params: { messageId, archived }
    });
  }

  getAllLookups(): Observable<any> {
    if (!this.allLookups$) {
      this.allLookups$ = this.http.get(this.baseUrl + 'GetAllLookups', this.config).pipe(
        shareReplay(1)
      );
    }
    return this.allLookups$;
  }

  getAdminInbox(filters: messageViewingFilters): Observable<Inbox> {
    return this.http.post(this.baseUrl + 'GetAdminInbox', filters, this.config);
  }

  getAdminInboxNewOnly(filters: messageViewingFilters): Observable<Inbox> {
    return this.http.post(this.baseUrl + 'GetAdminInboxNewOnly', filters, this.config);
  }
}
